import { defineComponent, PropType } from "vue";
import { NSpin } from "naive-ui";

import { Station } from "~/api/models/station.model";
import AvoltaMap from "~/components/leaflet-map/avolta-map.vue";
import WidgetBase from "~/components/widget-base/widget-base";


export default defineComponent({

    components: {
        AvoltaMap,
        NSpin,

        WidgetBase
    },

    props: {
        stations: { type: Array as PropType<Station[]>, default: () => []},
        loading: { type: Boolean, default: false }
    },

    computed: {
        stationList(): Station[] {
            return this.stations && this.stations.filter((station: Station) => station.location?.lat && station.location?.lon) || [];
        },
    },
});